import { render, staticRenderFns } from "./BillsNotify.vue?vue&type=template&id=dbd463c0&"
import script from "./BillsNotify.js?vue&type=script&lang=js&"
export * from "./BillsNotify.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports